import InAppPurchase from '@/lib/base/inAppPurchase';
import {
  getMarketSalePages,
  getMarketCategories,
  getMarketSalePage,
  getSalePageProduct,
} from '@/services/ec';
import {CURRENCY_MAPPING, LANGUAGE} from '@/constant/language';
import i18n from '@/i18n/index.js';

const state = {
  salePageList: [],
};

const actions = {
  async getSalePages({commit}) {
    const [salePages, categories] = await Promise.all([
      getMarketSalePages(),
      getMarketCategories(),
      InAppPurchase.init(),
    ]);
    let salePageIds = [];
    categories.forEach((category) => {
      category.marketSalePageIds.forEach((id) => {
        salePageIds.push(id);
      });
    });
    salePageIds = [...new Set(salePageIds)];
    let salePageDocs = salePages;
    if (InAppPurchase.isActive) {
      salePageDocs = salePages
        .map((salePage) => {
          const products = salePage.products || [];
          let newProducts = products.map((product) => {
            const inAppPurchaseId = product.inAppPurchaseId;
            const inAppProduct = InAppPurchase.getProduct(inAppPurchaseId);
            product.inAppProduct = inAppProduct;
            return product;
          });
          newProducts = newProducts.filter((product) => !!product.inAppProduct);
          salePage.products = newProducts;
          return salePage;
        })
        .filter((salePage) => (salePage.products || []).length > 0);
    }
    const mapping = {};
    salePageDocs.forEach((doc) => {
      mapping[doc.marketSalePageId] = doc;
    });
    commit(
      'setSalePageList',
      salePageIds.map((id) => mapping[id]).filter((doc) => !!doc)
    );
  },
  async getSalePage({rootGetters}, marketSalePageId) {
    const [salePage] = await Promise.all([
      getMarketSalePage(marketSalePageId),
      InAppPurchase.init(),
    ]);
    let products = salePage.products || [];
    if (InAppPurchase.isActive) {
      products = products.map((product) => {
        const inAppPurchaseId = product.inAppPurchaseId;
        const inAppProduct = InAppPurchase.getProduct(inAppPurchaseId);
        product.inAppProduct = inAppProduct;
        return product;
      });
      products = products.filter((product) => !!product.inAppProduct);
      if (!salePage.products?.length) return null;
    }
    const currency =
      CURRENCY_MAPPING[i18n.locale] || CURRENCY_MAPPING[LANGUAGE.EN_US];
    const userData = rootGetters['user/userData'];
    const username = userData?.username;
    const mapping = {};
    const promises = products.map(async (product) => {
      const productDetail = await getSalePageProduct({
        currency,
        username,
        marketSalePageId,
        productId: product.id,
      });
      mapping[product.id] = productDetail;
    });
    await Promise.all(promises);
    salePage.products = products.map((product) => {
      return {
        ...product,
        ...mapping[product.id],
      };
    });
    return salePage;
  },
};

const mutations = {
  setSalePageList(state, value) {
    state.salePageList = value;
  },
};

export default {
  namespaced: true,
  state,
  getters: {},
  actions,
  mutations,
};
